export default __webpack_public_path__ + "static/media/headphone.2a21f9ee.png";